var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"settings-page"}},[_c('div',{staticClass:"settings-page-container"},[_c('block-header-standard',{attrs:{"title":_vm.t('settings')}}),_c('div',{staticClass:"settings-form-container"},[_c('settings-form')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }